<template>
  <div class="KCCSH_Class">
    <div class="headerSearch">
      <div class="sousuo">
        <el-form
          ref="search"
          :model="searchForm"
          label-width="90px"
          style="display: flex"
          label-position="left"
        >
          <el-form-item label="化学品:" style="">
            <el-input
              v-model="searchForm.hxpMc"
              placeholder="请输入化学品"
            />
          </el-form-item>
          <el-form-item label="仓库名称:">
            <el-input
              v-model="searchForm.ckmc"
              placeholder="请输入仓库名称"
            />
          </el-form-item>
          <el-form-item label="登记日期:">
            <el-col :span="11">
              <el-date-picker
                v-model="searchForm.beginDjsj"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="选择日期"
                :picker-options="startTime"
                style="width: 100%"
              />
            </el-col>
            <el-col style="text-align: center" class="line" :span="2">-</el-col>
            <el-col :span="11">
              <el-date-picker
                v-model="searchForm.endDjsj"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="选择日期"
                :picker-options="endTime"
                style="width: 100%"
              />
            </el-col>
          </el-form-item>
          <el-button
            type="primary"
            round
            class="sousuoButton"
            @click="sousuo"
          >搜索</el-button>
        </el-form>
      </div>
    </div>
    <div
      style="
        width: 95%;
        max-width: 1518px;
        margin: 0 auto;
        background-color: white;
        padding-top: 40px;
        padding-bottom: 51px;
        margin: 0 auto;
      "
    >
      <div class="tablemes">
        <el-table
          ref="cktable"
          v-loading="loading"
          fit
          :data="tableData"
          border
          :show-overflow-tooltip="true"
          :header-cell-style="{ background: '#F2F2F2' }"
          style="width: 100%"
          @select="select"
        >
          <el-table-column>
            <template slot="header">
              <el-button
                type="primary"
                class="addButton"
                size="mini"
                icon="el-icon-plus"
                @click="addPupShow"
              >新增</el-button>
              <el-button
                v-preventReClick
                size="mini"
                @click="daochu"
              >导出</el-button>
              <el-button
                v-if="lc == 1"
                v-preventReClick
                size="mini"
                type="primary"
                @click="InitFinish"
              >初始化完毕</el-button>
            </template>

            <el-table-column
              v-for="(item, i) in table"
              :key="i"
              align="center"
              :label="item.label"
              :prop="item.key"
              :show-overflow-tooltip="true"
            >
              <template slot-scope="scope">
                <span
                  v-if="item.key == 'zt'"
                  :style="[
                    item.key == 'zt' && scope.row.zt == '00'
                      ? { color: 'blue' }
                      : { color: '#1B9200' },
                  ]"
                >
                  {{ scope.row.zt == "00" ? "草稿" : "已初始化" }}
                </span>
                <span
                  v-else-if="item.key == 'cskc'"
                >{{ scope.row.cskc }}{{ scope.row.cskcDwLabel }}</span>
                <span v-else> {{ scope.row[item.key] }}</span>
              </template>
            </el-table-column>
            <el-table-column
              header-align="center"
              align="left"
              width="200px"
              label="操作"
            >
              <template slot-scope="scope">
                <div style="text-align: center">
                  <el-button
                    v-if="scope.row.zt == '01'"
                    size="mini"
                    type="primary"
                    icon="el-icon-document"
                    @click="handleQuery(scope.row.zt, scope.row)"
                  >查看</el-button>
                  <el-button
                    v-if="scope.row.zt == '00'"
                    type="primary"
                    class="editButton"
                    icon="el-icon-delete"
                    size="mini"
                    @click="edit(scope.row.id, scope.row)"
                  >编辑</el-button>
                  <el-button
                    v-if="scope.row.zt == '00'"
                    type="primary"
                    class="deleteButton"
                    icon="el-icon-delete"
                    size="mini"
                    @click="shanchu(scope.row.id)"
                  >删除</el-button>
                </div>
              </template>
            </el-table-column>
          </el-table-column>
        </el-table>

        <el-pagination
          background
          layout="prev, pager,next,jumper,total,sizes"
          :page-sizes="[10, 20, 30, 40]"
          :total="total"
          :page-size="pagesize"
          class="el-page"
          :current-page.sync="currentPage"
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
        />
      </div>
    </div>

    <el-dialog
      v-if="dialogVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :title="titleText"
      :visible.sync="dialogVisible"
      destroy-on-close
      center
      width="953px"
    >
      <KCAdd :row-i-d="rowID" :lc="lc" :type="caozuoType" />
    </el-dialog>
  </div>
</template>
<script>
import KCAdd from './KCAdd.vue'
import {
  getKccshList,
  remove,
  excelwriter,
  finishKcCsh
} from '@/assets/js/kccsh'
export default {
  components: { KCAdd },
  props: ['lc'],
  data() {
    return {
      startTime: {
        disabledDate: (time) => {
          if (this.searchForm.endDjsj) {
            return time.getTime() > new Date(this.searchForm.endDjsj).getTime()
          } else {
            return time.getTime() > Date.now()
          }
        }
      },
      endTime: {
        disabledDate: (time) => {
          if (this.searchForm.beginDjsj) {
            return (
              time.getTime() > Date.now() ||
              time.getTime() < new Date(this.searchForm.beginDjsj).getTime()
            )
          } else {
            return time.getTime() > Date.now()
          }
        }
      },
      loading: true,
      rowID: '',
      caozuoType: '',
      leixing: '',
      titleText: '',
      dialogVisible: false,
      dialogVisible2: false,
      table: [
        {
          key: 'kccshBh',
          label: '库存初始化编号'
        },
        {
          key: 'hxpMc',
          label: '化学品名称'
        },

        {
          key: 'ckmc',
          label: '仓库名称'
        },
        {
          key: 'cskc',
          label: '初始库存数量'
        },
        {
          key: 'bgyxm',
          label: '保管员'
        },
        {
          key: 'djsj',
          label: '登记日期'
        },
        {
          key: 'zt',
          label: '状态'
        }
      ],
      tableData: [], // 表格数据
      total: 0, // 总条数
      currentPage: 1, // 当前页
      pagesize: 10, // 每页的数据条数
      searchForm: {
        hxpMc: '',
        ckmc: '',
        beginDjsj: '',
        endDjsj: ''
      },

      multipleSelection: []
    }
  },
  computed: {
    isInit() {
      var that = this
      return JSON.parse(that.$cookies.get('isInit'))
    }
  },
  watch: {},
  created() {
    this.getTableData()
  },
  mounted() {},
  beforeDestroy() {},
  methods: {
    daochu() {
      excelwriter(this.searchForm).then((e) => {
        const table = '库存初始化'
        const a = document.createElement('a')
        const blob = new Blob([e.data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8'
        })
        const objectUrl = URL.createObjectURL(blob)
        a.setAttribute('href', objectUrl)
        a.setAttribute('download', table + '.xlsx')
        a.click()
      })
    },
    InitFinish() {
      var that = this
      this.$confirm('是否确认库存初始化完毕?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          finishKcCsh().then((e) => {
            that.$router.push('/Dashboard')
            if (e.data.code == '000000') {
              this.$message({
                type: 'success',
                message: '库存初始化成功!'
              })
              window.location.reload()
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          })
        })
    },
    select(row) {},
    sousuo() {
      this.currentPage = 1
      this.getTableData()
    },
    handleCurrentChange(val) {
      this.currentPage = val // 当前页
      this.getTableData()
    },
    // 10条/页改变时
    handleSizeChange(val) {
      this.pagesize = val
      this.getTableData()
    },
    toggleSelection(rows) {},
    handleSelectionChange(val) {},

    handleQuery(type, row) {
      this.dialogVisible = true
      if (type == '00') {
        this.caozuoType = 'add'
      } else if (type == '01') {
        this.caozuoType = 'query'
      }
      this.titleText = '查看库存初始化'
      this.rowID = row.id
    },
    addPupShow() {
      this.dialogVisible = true
      this.titleText = '新增库存初始化'
      this.rowID = ''
      this.caozuoType = 'add'
    },
    edit(id) {
      this.dialogVisible = true
      this.caozuoType = 'add'
      this.rowID = id
      this.titleText = '编辑库存初始化'
    },
    shanchu(data) {
      remove(data).then(() => {
        this.getTableData()
        this.$message({
          message: '删除成功!',
          type: 'success'
        })
      })
    },
    getTableData() {
      getKccshList({
        page: this.currentPage,
        size: this.pagesize,
        param: this.searchForm
      })
        .then((e) => {
          this.loading = false
          this.tableData = e.data.data.rows
          this.total = e.data.data.total
        })
        .catch(() => {
          this.loading = false
        })
    }
  }
}
</script>
<style scoped lang='less'>
/deep/.el-dialog--center .el-dialog__body {
  text-align: initial;
  padding: 25px 80px 30px !important;
}
/deep/.el-form--inline .el-form-item__content {
  display: inline-block;
  vertical-align: middle !important;
}
/deep/.el-table--border {
  border-right: none;
  border-bottom: none;
  z-index: 0 !important;
}
.KCCSH_Class {
  .headerSearch {
    width: 95%;
    max-width: 1518px;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 11px;
    margin-top: 30px;
    background-color: white;
    padding: 30px 0 20px 0;
    // border: 1px solid red;
    display: flex;
    align-items: center;
    box-shadow: 0px 1px 27px 3px rgba(0, 0, 0, 0.05);
    border-radius: 5px;
    font-size: 15px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
    .el-form-item {
      margin-bottom: 10px;
      margin-right: 30px;
      &:last-child {
        width: 90px;
        height: 39px;
        /deep/ .el-button {
          width: 90px !important;
          height: 39px;
          border-radius: 3px;
        }
      }
    }
  }

  .sousuo {
    width: 90%;
    margin-left: auto;
    margin-right: auto;
    .sousuoButton {
      width: 90px;
      height: 39px;
      background: #4170ff;
      // border-radius: 3px;
      border-color: #4170ff;
    }
  }
  .tablemes {
    width: 90%;
    margin: auto;
    max-width: 1375px;
    margin-bottom: 57px;
    .el-pagination__total {
      margin-left: 8px;
    }
    .el-pagination {
      padding: 10px 0;

      border: 1px solid #ebeef5;
      border-top: 0;
    }
    .addButton {
      color: #fff;
      background: #4170ff;
      border-radius: 3px;
      border-color: #4170ff;
    }
    .el-button--primary {
      color: #fff;
      // width: 59px;
      // height: 26px;
      background: #4170ff;
      border-radius: 3px;
      border-color: #4170ff;
    }
    .deleteButton {
      background: #ff5721 !important;
      border-color: #ff5721 !important;
    }
    .editButton {
      color: #fff;
      background: #4170ff;
      border-radius: 3px;
      border-color: #4170ff;
    }
    .el-pager {
      .number {
        background: #4170ff;
        border-color: #4170ff;
      }
    }
  }
  .el-page {
    // width: 90px;
    // height: 39px;
    .el-pager {
      .active {
        background: #4170ff;
        border-radius: 3px;
        border-color: #4170ff;
      }
    }
  }
}
/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #4170ff !important;
  color: #fff;
}
</style>
